<template>
  <div>
    <MainNavigation />
    <div id="content_wrapper">
      <transition name="fade">
        <router-view :key="route()" v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </transition>
    </div>
    <FooterEl />

    <cookie-consent>
      <template #message>
        <p>
          We use cookies to personalise content, and to analyse our traffic. Learn more in our
          <router-link to="/Privacy"> Privacy Policy. </router-link>
        </p>
      </template>
      <template #button>
        <button class="btn btn-info">Accept Cookies</button>
      </template>
    </cookie-consent>
  </div>
</template>

<script>
import MainNavigation from '@/components/MainNavigation.vue'
import FooterEl from '@/components/FooterEl.vue'
import CookieConsent from 'vue-cookieconsent-component'

export default {
  name: 'App',
  components: {
    MainNavigation,
    FooterEl,
    CookieConsent,
  },
  methods: {
    route() {
      console.log('path', this.$route.path)
      return this.$route.path
    },
  },
}
</script>

<style lang="scss">
@import '@/scss/averta/style.scss';
@import '@/scss/_media_queries.scss';
@import '@/scss/_variables.scss';
@import '@/scss/_general.scss';

#content_wrapper {
  padding: 0 var(--gutter);
}

.cookie-consent {
  position: fixed;
  z-index: 9999;
  width: 100%;
  // padding: 1rem 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  left: 0;
  right: 0;
  bottom: 0;

  font-size: 16px;
  background: $grayL;
  box-shadow: 0 -5px 20px 0 rgba(0, 0, 0, 0.1);

  p {
    margin: 18px 30px;
    text-align: center;
  }

  a {
  }

  section {
    margin: 18px 30px;
  }

  @include respond-below(md) {
  }

  @include respond-below(xs) {
    text-align: center;

    section {
      width: 100%;
      display: block;

      button {
        width: 100%;
      }
    }
  }

  @include respond-below(md) {
    p {
      width: 100%;
      margin-bottom: 0;
    }

    a {
      // display: block;
    }
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.fade-enter-active,
.fade-leave-active {
  animation: fadeIn 0.25s ease-in;
}

.fade-leave-active {
  animation-direction: reverse;
}

.fade-enter,
.fade-leave-to {
}
</style>
